import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import {
	clearClaimSession,
	getActiveManagedCompanyId,
	hasValidClaimSession,
	isAdminClaimSession,
} from "@/app/services/companies/claimSession.js";

import CompanyDashboardLayout from "./CompanyDashboardLayout";
import { CompanyDashboardProvider } from "./CompanyDashboardProvider";
import SetupPage from "./SetupPage";
import UpgradePage from "./UpgradePage";

function CompanyDashboardAccessGate({ children }) {
	const location = useLocation();

	if (!hasValidClaimSession()) {
		clearClaimSession();
		return <Navigate to="/companies" replace />;
	}

	if (isAdminClaimSession() && !getActiveManagedCompanyId()) {
		return <Navigate to="/companies" replace state={{ from: location }} />;
	}

	return children;
}

export function CompanyDashboardRoute() {
	return (
		<CompanyDashboardAccessGate>
			<CompanyDashboardProvider>
				<CompanyDashboardLayout />
			</CompanyDashboardProvider>
		</CompanyDashboardAccessGate>
	);
}

export function CompanyDashboardSetupRoute() {
	return (
		<CompanyDashboardAccessGate>
			<CompanyDashboardProvider>
				<SetupPage />
			</CompanyDashboardProvider>
		</CompanyDashboardAccessGate>
	);
}

export function CompanyDashboardUpgradeRoute() {
	return (
		<CompanyDashboardAccessGate>
			<CompanyDashboardProvider>
				<UpgradePage />
			</CompanyDashboardProvider>
		</CompanyDashboardAccessGate>
	);
}
